module.exports = __webpack_public_path__ + "img/BG831094393.445d3c29.png";